import { useState, useCallback } from "react";
import toast from "react-hot-toast";
import xml2js from "xml2js";

const TRANSACTION_DETAILS_ENDPOINT =
  process.env.REACT_APP_GET_CUSTOMER_EDI_TRANSACTIONS;
const APIKEY = process.env.REACT_APP_APIKEY;

function useFetchTransactionDetails() {
  const [transactionDetails, setTransactionDetails] = useState(null);
  const [transactionsLoading, setTransactionsLoading] = useState(false);
  const [transactionsError, setTransactionsError] = useState(null);

  const handleResponse = (data) => {
    xml2js.parseString(data, { explicitArray: false }, (err, result) => {
      if (err) {
        console.error("Failed to parse XML:", err);
        throw new Error("Error when parsing XML");
      }

      setTransactionDetails(result);
    });
  };

  const fetchFromApi = async (params, referenceIdentifier) => {
    const url = new URL(TRANSACTION_DETAILS_ENDPOINT);
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );

    console.log("params in fetchFromApi", params);
    console.log(
      "referenceIdentifier in fetchFromApi func: ",
      referenceIdentifier
    );

    const response = await fetch(url.toString(), {
      headers: {
        "x-api-key": APIKEY,
        "Reference-Identifier": referenceIdentifier || "",
      },
      method: "GET",
    });

    return response;
  };

  const fetchTransactions = useCallback(
    async (
      selected,
      referenceIdentifier,
      messageGroupId = null,
      documentType = null,
      messageFlowType = null,
      senderName = null,
      flowLinkType = null
    ) => {
      setTransactionsLoading(true);
      setTransactionsError(null);

      console.log("fetchTransactions called with:", {
        selected,
        referenceIdentifier,
        messageGroupId,
        documentType,
        messageFlowType,
        senderName,
        flowLinkType,
      });

      try {
        const params = messageGroupId
          ? {
              MessageGroupId: messageGroupId,
              ...(documentType && { DocumentType: documentType }),
            }
          : {
              CustomerName: selected,
              ...(messageFlowType && { MessageFlowType: messageFlowType }),
              ...(senderName && { SenderName: senderName }),
              ...(flowLinkType && { FlowLinkType: flowLinkType }),
             // ...(documentType && { DocumentType: documentType }), // Ensure it's included
            };

        console.log("params in fetchTransactions hook", params);
        console.log(
          "referenceIdentifier in fetchTransactions hook",
          referenceIdentifier
        );

        const res = await fetchFromApi(params, referenceIdentifier);
        if (res.ok) {
          const data = await res.text();
          handleResponse(data);
        } else {
          let errorMessage = "An unexpected error occurred.";
          switch (res.status) {
            case 400:
              errorMessage = "Bad Request - The request was invalid.";
              break;
            case 401:
              errorMessage = "Unauthorized - Authentication required.";
              break;
            case 403:
              errorMessage =
                "Forbidden - You don't have permission to access this resource.";
              break;
            case 404:
              errorMessage = "Not Found - The resource could not be found.";
              break;
            case 500:
            default:
              errorMessage = "Internal Server Error - Please try again later.";
              break;
          }
          throw new Error(errorMessage);
        }
      } catch (error) {
        console.error("Error fetching transaction details:", error);
        setTransactionsError(error.message);
        toast.error(error.message);
      } finally {
        setTransactionsLoading(false);
      }
    },
    []
  );

  return {
    fetchTransactions,
    transactionDetails,
    transactionsLoading,
    transactionsError,
  };
}

export default useFetchTransactionDetails;
